export default "__VITE_ASSET__D1QH63Zb__"